import styled from "@emotion/styled";
import { Button, Menu, Tab, Tabs } from "@mui/material";

export const TabsContainer = styled(Tabs)(() => ({
    backgroundColor: "#c420ff",
    borderRadius: "0px",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,0.2), 0 4px 20px 0 rgba(0,0,0,0.19)",
    position: "sticky",
    top: 0,
    zIndex:1
}))
export const CustomTab = styled(Tab)(() => ({
    fontWeight: "bold",
    color: "white",
    fontSize: "19px"
}));
export const MenuButton = styled(Button)(() => ({
    width: "100%",
    padding: "8px",
    backgroundColor: "#c420ff",
    color: "white",
    fontWeight: "bold",
    borderRadius: "0px",
    fontSize: "19px",
    position: "sticky",
    top: 0,
    zIndex:1,
    '&>span': {
        pointerEvents: "none",
    },
    '&>span>svg': {
        fontSize: "30px !important"
    },
    '&:hover':{
        backgroundColor:"#c420ff"
    }
}));
export const CustomMenu = styled(Menu)(() => ({
    '& .MuiMenu-paper': {
        width: "100%",
        maxWidth: "100%",
        left: "0px !important"
    },
    '& .MuiMenu-list': {
        backgroundColor: "#f04444",
        '&>li': {
            justifyContent: "center",
            fontWeight: "bold",
            color: "white",
            '&>p': {
                fontWeight: "bold",
                fontSize: "19px"
            }
        }
    }
}));